import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { apolloService } from '../../common/services'

import { MENU_CURATION_TASK_QUERY } from '../../menu-curation-tasks/graphql/queries'
import { REFRESH_MENU_CURATION_TASK } from '../../menu-curation-tasks/redux/action-types'
import { UPDATE_DISH_TYPE_BY_MENU_TITLE_MUTATION } from '../graphql/mutations'
import { UPDATE_DISH_TYPE_BY_MENU_TITLE } from '../redux/action-types'

const useUpdateDishTypeByMenuTitleMutation = () => {
  const dispatch = useDispatch()
  const { id: menuCurationTaskId } = useParams()

  const {
    isDishTypeMenuTitleUpdateLoading: isLoading,
    dishTypeMenuTitleUpdateError: error,
  } = useSelector(store => store.dishes.dishes)

  const onSuccess = useCallback(
    () =>
      apolloService.query({
        query: MENU_CURATION_TASK_QUERY,
        variables: { id: menuCurationTaskId },
        dispatch,
        action: REFRESH_MENU_CURATION_TASK,
      }),
    [dispatch, menuCurationTaskId],
  )

  const mutate = useCallback(
    (dishTypeId, menuTitleId) =>
      apolloService.mutate({
        mutation: UPDATE_DISH_TYPE_BY_MENU_TITLE_MUTATION,
        variables: { dishTypeId, menuTitleId },
        dispatch,
        action: UPDATE_DISH_TYPE_BY_MENU_TITLE,
        onSuccess,
      }),
    [dispatch, onSuccess],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateDishTypeByMenuTitleMutation
